export default __webpack_public_path__ + "static/media/music-small.2541f511.jpg";